import styled from "styled-components/macro";
import {device} from "../../device";

export const StyledPasswordReset = styled.div`
    margin-top: 1rem;
`

export const StyledContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-template-rows: minmax(400px, 1fr);
    border-radius: 4px;
    text-align: left;
    @media ${device.tablet}{
        grid-template-columns: 1fr;
    }
`

export const NotificationContainer = styled.div`
    background: #34D399
    padding: 2rem 1rem;
`